import React from 'react';
import { Home, Trophy, Users, ShoppingBag, User } from 'lucide-react';
import { cn } from '../../lib/utils';
interface BottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const tabs = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'ranks',
    icon: Trophy,
    label: 'Ranks'
  }, {
    id: 'friends',
    icon: Users,
    label: 'Friends'
  }, {
    id: 'shop',
    icon: ShoppingBag,
    label: 'Shop'
  }, {
    id: 'profile',
    icon: User,
    label: 'Profile'
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 px-4 pb-safe pt-2 h-20 flex items-center justify-around z-40" data-id="element-193">
      {tabs.map(tab => {
      const Icon = tab.icon;
      const isActive = activeTab === tab.id;
      return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={cn('flex flex-col items-center gap-1 p-2 rounded-xl transition-all', isActive ? 'text-blue-500' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-50')} data-id="element-194">
            <Icon size={24} strokeWidth={isActive ? 2.5 : 2} data-id="element-195" />
            {/* <span className="text-[10px] font-bold">{tab.label}</span> */}
          </button>;
    })}
    </div>;
}